import React, {useEffect, Component} from 'react';
import {Helmet} from 'react-helmet';
import axios from 'axios';
import socketIOClient from 'socket.io-client';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import AsyncStorage from '@callstack/async-storage';
import {BrowserRouter as Router, Switch, Route, Link, Redirect} from 'react-router-dom';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import '../assets/css/IntlTelInput.css';
import Header_component from '../includes/Header_component';
import Footer_component from '../includes/Footer_component';
// import '../assets/css/adminlte.min.css';
import useScript, {loadCSS, removeCSS} from '../utils/useScript';
// import '../assets/css/innerpages_customstyle.css';
import '../assets/css/icheck-bootstrap.min.css';
import '../assets/font-awesome-5.13.0/css/all.css';
// import useScript from './../utils/useScript';
import {appendScript} from '../utils/appendScript';
import redtie_logo from '../assets/img/redtie_logo.png';
import no_image from '../assets/img/no_image.png';
import plivo_logo from '../assets/img/plivo_logo.png';
import twilio_logo from '../assets/img/twilio_logo.png';
import bandwidth_logo from '../assets/img/bandwidth_logo.png';
import transparent from '../assets/img/transparent.png';
import {render} from 'react-dom';
import $ from 'jquery';
import PinInput from 'react-pin-input';
import moment from 'moment';
import {ToastContainer, toast, Flip} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {StripePaymentElement} from '../includes/StripeElementRenew';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';

// // Make sure to call `loadStripe` outside of a component’s render to avoid
// // recreating the `Stripe` object on every render.
const API_CALL_ENDPOINT = process.env.REACT_APP_APICALL_ENDPOINT;
const ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const PAYMENTENDPOINT = process.env.REACT_APP_API_PAYMENT_ENDPOINT;
const STRIPE_PUBLISHABLE_KEY =`${process.env.STRIPE_PUBLISHABLE_KEY}`;
const stripePromise = loadStripe('pk_0CXenBSAR2YemYmXkh4QoTyamq0ab');
const appearance = {
  theme: 'stripe',
};
var payment_client_secret_id = '';
const CLIENT_SECRET = 'pi_1GeGlLFhKFuUO2SlEDG4gHVG_secret_Yw4BSOLoNrfNgVyhdHabYcgkT';
const options = {
  payment_client_secret_id,
  appearance,
};
var countryLists = ['in', 'us', 'ca'];
const API_KEY = process.env.REACT_APP_V4_API_KEY;
const API_SECRET = process.env.REACT_APP_V4_API_SECRET;
let url = window.location.href;
let params = queryString.parse(url);
if (params?.verified === 'true') {
  localStorage.setItem('token', 'loggedIn');
  AsyncStorage.setItem('user_id', params?.user);
  AsyncStorage.setItem('business_id', params?.profile);
}
function validate(name, cardNumber, expirationdate, cvv) {
  // we are going to store errors for all fields
  // in a signle array
  const errors = [];
  if (name.length === 0) {
    errors.push("Name on card can't be empty");
    return errors;
  }

  if (cardNumber.length === 0) {
    errors.push("CardNumber can't be empty");
    return errors;
  }
  // if (cardNumber.value !== /^[0-9]+$/) {
  //   errors.push("Cardnumber can only be numeric");
  //   return errors;
  // }
  if (expirationdate.length === 0) {
    errors.push("Expiration Date can't be empty");
    return errors;
  }
  if (cvv.length === 0) {
    errors.push("Cvv can't be empty");
    return errors;
  }

  return errors;
}

// const $ = () => window.$;
export default class RenewProfile extends Component {
  // export default function CreateProfile() {
  constructor(props) {
    super(props);
    const token = localStorage.getItem('token');
    // this.logout = this.logout.bind(this);
    this.planchoose = this.planchoose.bind(this);
    this.back = this.back.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitServiceProvider = this.onSubmitServiceProvider.bind(this);
    this.failedonSubmit = this.failedonSubmit.bind(this);
    this.failedonSubmitServiceProvider = this.failedonSubmitServiceProvider.bind(this);
    this.onChangecardnumber = this.onChangecardnumber.bind(this);
    this.onChangecardname = this.onChangecardname.bind(this);
    this.onChangeexpdate = this.onChangeexpdate.bind(this);
    this.onChangecvc = this.onChangecvc.bind(this);
    this.onChangecard_id = this.onChangecard_id.bind(this);
    this.onPayexistCard = this.onPayexistCard.bind(this);
    this.getTempIDForExistcard = this.getTempIDForExistcard.bind(this);
    this.getTempID = this.getTempID.bind(this);
    this.failedonPayexistCard = this.failedonPayexistCard.bind(this);
    this.onPayexistCardServiceProvider = this.onPayexistCardServiceProvider.bind(this);
    this.failedonPayexistCardServiceProvider = this.failedonPayexistCardServiceProvider.bind(this);
    this.verify_number = this.verify_number.bind(this);
    this.phoneverify_clk = this.phoneverify_clk.bind(this);
    this.update_trial_name = this.update_trial_name.bind(this);
    this.onChange_trial_businessname = this.onChange_trial_businessname.bind(this);

    // this.onChangestripeplan = this.onChangestripeplan.bind(this);

    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }
    this.state = {
      loggedIn,
      plan_name: '',
      plan_details: {},
      plan_id: '',
      stripe_plan: '',
      card_name: '',
      user_id: '',
      business_id: '',
      user_email: '',
      card_number: '',
      exp_date: '',
      exp_month: '',
      exp_year: '',
      cvc: '',
      cardList: [],
      existcard_id: '',
      payment_type: 'stripe',
      errors: [],
      plans: [],
      plans_year: [],
      plan1: [],
      plan2: [],
      plan3: [],
      isLoading: false,
      paymentfailed: false,
      CreateProfileclass: 'all_contentcntr_1024',
      business_list_data: true,
      user_phone_number: '',
      user_phone_number_code: '',
      timerValue: 30,
      user_otp: '',
      Trial_phone_number: '',
      appsumo: 'false',
      run: false,
      cntus_cls: '',
      cntus_msg: '',
      add_month: moment().add(1, 'months').calendar(),
      add_year: moment().add(1, 'years').calendar(),
      promo_code: '',
      free_exist: false,
      enabled_country_lists: '',
      cclists: [],
      temp_business_id: '',
      payment_process_text: '',
      action_required: false,
      payment_client_secret: '',
      subscription_id: '',
      payment_intent: '',
      business_details: [],
    };
  }
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };
  onChangecard_id(e) {
    if (e.target.value == 'Select') {
      this.setState({existcard_id: ''});
    } else {
      this.setState({existcard_id: e.target.value});
    }
  }
  onChangecardnumber(e) {
    e.target.value = e.target.value
      .replace(/[^\dA-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
    this.setState({card_number: e.target.value});
  }
  onChangecardname(e) {
    // const errors = [];
    var regx = /^[a-zA-Z\s]*$/;
    if (regx.test(e.target.value)) {
      this.setState({card_name: e.target.value});
    }
    // e.target.value = e.target.value.replace(/^[A-Za-z ]+$/,'').replace(/[^\d\/]/g,'').trim();
    // e.target.value = e.target.value.replace(/^([a-zA-Z0-9 _-]+)$/, '').trim();
    // this.setState({ card_name: e.target.value })
  }
  onChangeexpdate(e) {
    e.target.value = e.target.value
      .replace(/^(\d\d)(\d)$/g, '$1/$2')
      .replace(/[^\d\/]/g, '')
      .trim();
    this.setState({exp_date: e.target.value});
  }
  onChangecvc(e) {
    // const re = /^[0-9\b]+$/;
    e.target.value = e.target.value
      .replace(/[^\dA-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
    this.setState({cvc: e.target.value});
  }

  getTempID = () => {
    const TempID = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/business/temp/id', TempID)
      .then((res) => {
        console.log('res.data.result', res.data.result);
        this.setState({business_id: res.data.result.id});
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getTempIDForExistcard = (e) => {
    e.preventDefault();
    const TempID = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/business/temp/id', TempID)
      .then((res) => {
        console.log('res.data.result', res.data.result);
        this.setState({business_id: res.data.result.id});
        this.onPayexistCard();
        // document.getElementById('chooseplandtls_div').style.display = 'block';
      })
      .catch((error) => {
        console.log(error);
      });
  };

  payment_process_faild() {
    if (!this.state.action_required) {
      $('.processing_div').hide();
    }
  }
  onPayexistCard() {
    $('.processing_div').show();
    this.setState({isLoading: true});
    const existcardpayment = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      plan_id: this.state.plan_id,
      stripe_plan: this.state.stripe_plan,
      payment_type: this.state.payment_type,
      card_id: this.state.existcard_id,
      temp_business_id: this.state.business_id,
    };
    // console.log(userpayment)
    axios
      .post(API_CALL_ENDPOINT + '/profile/payment/create', existcardpayment)
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 'success') {
          this.setState({isLoading: false});
          this.setState({paymentfailed: false, business_id: res.data.result.business_id});
          AsyncStorage.setItem('business_id', this.state.business_id);
          AsyncStorage.setItem('plan_id', this.state.plan_id);
          // this.props.history.push('/create-profile1');
        }
        console.log(res.data.error.message);
        const errors = [];
        if (res.data.error) {
          if (res.data.error.reason == 'payment error') {
            this.setState({paymentfailed: true});
          }
          this.setState({isLoading: false});
          errors.push(res.data.error.message);
          this.setState({errors});
          setTimeout(() => {
            this.setState({errors: []});
            // document.getElementById("error").remove();
            // document.getElementById('error').style.display = 'none'
          }, 3000);
          return errors;
        }
      })
      .catch((error) => {
        if (error.response) {
          const errors = [];
          if (error.response.data.error) {
            if (error.response.data.error.reason == 'payment error') {
              this.setState({paymentfailed: true});
            }
            $('.processing_div').hide();
            toast.dark(error.response.data.error.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            this.setState({isLoading: false});
            // errors.push(error.response.data.error.message);
            // this.setState({errors});
            // setTimeout(() => {
            //   this.setState({errors: []});
            //   // document.getElementById("error").remove();
            //   // document.getElementById('error').style.display = 'none'
            // }, 3000);
            // return errors;
          }
        }
      });
  }
  failedonPayexistCard(e) {
    e.preventDefault();
    const existcardpayment = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      plan_id: this.state.plan_id,
      stripe_plan: this.state.stripe_plan,
      payment_type: this.state.payment_type,
      card_id: this.state.existcard_id,
    };
    // console.log(userpayment)
    axios
      .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 'success') {
          this.setState({isLoading: false});
          this.setState({paymentfailed: false});
          AsyncStorage.setItem('business_id', res.data.result.business);
          AsyncStorage.setItem('plan_id', res.data.result.plan_id);
          this.props.history.push('/create-profile1');
        }
        console.log(res.data.error.message);
        const errors = [];
        if (res.data.error) {
          if (res.data.error.reason == 'payment error') {
            this.setState({paymentfailed: true});
          }
          this.setState({isLoading: false});
          errors.push(res.data.error.message);
          this.setState({errors});
          setTimeout(() => {
            this.setState({errors: []});
            // document.getElementById("error").remove();
            // document.getElementById('error').style.display = 'none'
          }, 3000);
          return errors;
        }
      })
      .catch((error) => {
        if (error.response) {
          const errors = [];
          if (error.response.data.error) {
            if (error.response.data.error.reason == 'payment error') {
              this.setState({paymentfailed: true});
            }
            this.setState({isLoading: false});
            errors.push(error.response.data.error.message);
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
              // document.getElementById("error").remove();
              // document.getElementById('error').style.display = 'none'
            }, 3000);
            return errors;
          }
        }
      });
  }
  failedonSubmit(e) {
    this.setState({isLoading: true});
    e.preventDefault();
    const {card_name, stripe_plan, plan_id, user_id, card_number, exp_date, cvc} = this.state;

    const errors = validate(card_name, card_number, exp_date, cvc);
    if (errors.length > 0) {
      this.setState({errors});
      this.setState({isLoading: false});
      setTimeout(() => {
        this.setState({errors: []});
        // this.props.history.push('/')
        // document.getElementById('error').style.display='none'
      }, 3000);
      return;
    } else {
      if (this.state.cardList.length > 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const card_create = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
        };
        console.log(card_create);
        axios
          .post(API_CALL_ENDPOINT + '/stripe/cards/create', card_create)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              const userpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                plan_id: this.state.plan_id,
                business_id: this.state.business_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.card_id,
              };
              console.log(userpayment);
              //  return

              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/update', userpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business);
                    AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                    this.props.history.push('/create-profile1');
                  }
                  console.log(res.data.error.message);
                  if (res.data.error) {
                    if (res.data.error.reason == 'payment error') {
                      this.setState({paymentfailed: true});
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      if (error.response.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            if (res.data.status == 'conflict') {
              const existcardpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                plan_id: this.state.plan_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.details.card_no,
              };
              // console.log(userpayment)
              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business);
                    AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                    this.props.history.push('/create-profile1');
                  }
                  console.log(res.data.error.message);
                  const errors = [];
                  if (res.data.error) {
                    if (res.data.error.reason == 'payment error') {
                      this.setState({paymentfailed: true});
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      if (error.response.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            // console.log(res.data.error.message)
            if (res.data.error) {
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                  // document.getElementById("error").remove();
                  // document.getElementById('error').style.display = 'none'
                }, 3000);
                return errors;
              }
              if (error.response.data.status == 'conflict') {
                const existcardpayment = {
                  apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                  secret: 'R1eqD2twI3E4',
                  user_id: this.state.user_id,
                  business_id: this.state.business_id,
                  plan_id: this.state.plan_id,
                  stripe_plan: this.state.stripe_plan,
                  payment_type: this.state.payment_type,
                  card_id: error.response.data.result.details.card_no,
                };
                // console.log(userpayment)
                axios
                  .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
                  .then((res) => {
                    console.log(res.data);
                    if (res.data.status == 'success') {
                      this.setState({isLoading: false});
                      this.setState({paymentfailed: false});
                      AsyncStorage.setItem('business_id', res.data.result.business);
                      AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                      this.props.history.push('/create-profile1');
                    }
                    console.log(res.data.error.message);
                    const errors = [];
                    if (res.data.error) {
                      if (res.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(res.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  })
                  .catch((error) => {
                    if (error.response) {
                      if (error.response.data.error) {
                        if (error.response.data.error.reason == 'payment error') {
                          this.setState({paymentfailed: true});
                        }
                        this.setState({isLoading: false});
                        errors.push(error.response.data.error.message);
                        this.setState({errors});
                        setTimeout(() => {
                          this.setState({errors: []});
                          // document.getElementById("error").remove();
                          // document.getElementById('error').style.display = 'none'
                        }, 3000);
                        return errors;
                      }
                    }
                  });
              }
            }
          });
      }
      if (this.state.cardList.length == 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const userpayment = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
          plan_id: this.state.plan_id,
          stripe_plan: this.state.stripe_plan,
          payment_type: this.state.payment_type,
        };
        console.log(userpayment);
        //  return

        axios
          .post(API_CALL_ENDPOINT + '/profile/payment/update', userpayment)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              this.setState({paymentfailed: false});
              AsyncStorage.setItem('business_id', res.data.result.business);
              AsyncStorage.setItem('plan_id', res.data.result.plan_id);
              this.props.history.push('/create-profile1');
            }
            console.log(res.data.error.message);
            if (res.data.error) {
              if (res.data.error.reason == 'payment error') {
                this.setState({paymentfailed: true});
              }
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                if (error.response.data.error.reason == 'payment error') {
                  this.setState({paymentfailed: true});
                }
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                }, 3000);
                return errors;
              }
            }
          });
      }
    }
  }

  onSubmitStripe() {
    console.log('Submitted Form');
  }

  onSubmit(e) {
    this.setState({isLoading: true});
    e.preventDefault();

    console.log('data testing', $('#creditcarddtls_div').serialize());
    this.getTempID();
    const {card_name, stripe_plan, plan_id, user_id, card_number, exp_date, cvc} = this.state;
    const errors = validate(card_name, card_number, exp_date, cvc);
    if (errors.length > 0) {
      this.setState({errors});
      this.setState({isLoading: false});
      setTimeout(() => {
        this.setState({errors: []});
      }, 3000);
      return;
    } else {
      // if (this.state.cardList.length > 0) {
      $('.processing_div').show();
      var vals = this.state.exp_date.split('/');
      var exp_month = vals[0];
      var exp_year = vals[1];

      // const card_create = {
      //   apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      //   secret: 'R1eqD2twI3E4',
      //   user_id: this.state.user_id,
      //   card_name: this.state.card_name,
      //   card_number: this.state.card_number,
      //   exp_month: exp_month,
      //   exp_year: exp_year,
      //   cvc: this.state.cvc,
      // };
      // console.log(card_create);
      // axios
      //   .post(API_CALL_ENDPOINT + '/stripe/cards/create', card_create)
      //   .then((res) => {
      //     console.log(res.data);
      //     if (res.data.status == 'success') {
      //       this.setState({isLoading: false});
      // const userpayment = {
      //   apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      //   secret: 'R1eqD2twI3E4',
      //   user_id: this.state.user_id,
      //   plan_id: this.state.plan_id,
      //   stripe_plan: this.state.stripe_plan,
      //   payment_type: this.state.payment_type,
      //   // card_id: res.data.result.card_id,
      //   temp_business_id: this.state.business_id,
      // };
      // axios
      //   .post(API_CALL_ENDPOINT + '/subscription/create', userpayment)
      //   .then(async (res) => {
      //     console.log(res.data);
      //     if (res.data.status == 'success') {
      // var clientSecret = res.data.result.client_secret;
      // payment_client_secret_id= res.data.result.client_secret;
      // this.setState({isLoading: false,payment_client_secret:res.data.result.client_secret});
      // this.setState({paymentfailed: false});
      // AsyncStorage.setItem('business_id', res.data.result.business_id);
      // AsyncStorage.setItem('plan_id', this.state.plan_id);
      // this.props.history.push('/create-profile1');
      // let { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      //   payment_method: {
      //     card: cardElement,

      //   }
      // });
      // console.log('perror', error);
      //     console.log('paymentIntent', paymentIntent);
      // stripe
      //   .confirmCardPayment(clientSecret, {
      //     payment_method: {
      //       card: cardElement,
      //     },
      //   })
      //   .then((error, paymentIntent) => {
      //     console.log('perror', error);
      //     console.log('paymentIntent', paymentIntent);
      //   });
      // let { error, paymentIntent } = await stripe.confirmPayment(clientSecret, elements);
      //   }
      // })
      // .catch((error) => {
      //   if (error.response) {
      //     const errors = [];
      //     if (error.response.data.error) {
      //       $('.processing_div').hide();
      //       this.card_list();
      //       if (error.response.data.error.reason == 'payment error') {
      //         if (error.response.data.error.id) {
      //           this.setState({
      //             paymentfailed: true,
      //             business_id: error.response.data.error.id,
      //           });
      //           AsyncStorage.setItem('business_id', error.response.data.error.id);
      //         }
      //       }
      //       toast.dark(error.response.data.error.message, {
      //         position: 'top-right',
      //         transition: Flip,
      //         autoClose: 5000,
      //         hideProgressBar: true,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: undefined,
      //       });
      //       this.setState({isLoading: false});
      //     }
      //   }
      // });

      // .catch((error) => {
      //   if (error.response) {
      //     if (error.response.data.status == 'conflict') {
      //       const existcardpayment = {
      //         apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      //         secret: 'R1eqD2twI3E4',
      //         user_id: this.state.user_id,
      //         plan_id: this.state.plan_id,
      //         stripe_plan: this.state.stripe_plan,
      //         payment_type: this.state.payment_type,
      //         card_id: error.response.data.result.details.card_no,
      //         temp_business_id: this.state.business_id,
      //       };
      //       // console.log(userpayment)
      //       axios
      //         .post(API_CALL_ENDPOINT + '/profile/payment/create', existcardpayment)
      //         .then((res) => {
      //           console.log(res.data);
      //           if (res.data.status == 'success') {
      //             this.setState({isLoading: false});
      //             this.setState({paymentfailed: false});
      //             AsyncStorage.setItem('business_id', res.data.result.business_id);
      //             AsyncStorage.setItem('plan_id', this.state.plan_id);
      //             //   this.props.history.push('/create-profile1');
      //           }
      //         })
      //         .catch((error) => {
      //           const errors = [];
      //           if (error.response) {
      //             if (error.response.data.error) {
      //               this.card_list();
      //               $('.processing_div').hide();
      //               if (error.response.data.error.reason == 'payment error') {
      //                 if (error.response.data.error.id) {
      //                   this.setState({
      //                     paymentfailed: true,
      //                     business_id: error.response.data.error.id,
      //                   });
      //                   AsyncStorage.setItem('business_id', error.response.data.error.id);
      //                 }
      //                 toast.dark(error.response.data.error.message, {
      //                   position: 'top-right',
      //                   transition: Flip,
      //                   autoClose: 5000,
      //                   hideProgressBar: true,
      //                   closeOnClick: true,
      //                   pauseOnHover: true,
      //                   draggable: true,
      //                   progress: undefined,
      //                 });
      //               }
      //             }
      //           }
      //         });
      //     }
      //     if (error.response.data.error) {
      //       this.card_list();
      //       this.setState({isLoading: false});
      //       toast.dark(error.response.data.error.message, {
      //         position: 'top-right',
      //         transition: Flip,
      //         autoClose: 5000,
      //         hideProgressBar: true,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: undefined,
      //       });
      //       $('.processing_div').hide();
      //     }
      //   }
      // });
    }
  }

  failedonPayexistCardServiceProvider(e) {
    e.preventDefault();
    const existcardpayment = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      plan_id: this.state.plan_id,
      stripe_plan: this.state.stripe_plan,
      payment_type: this.state.payment_type,
      card_id: this.state.existcard_id,
    };
    // console.log(userpayment)
    axios
      .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 'success') {
          this.setState({isLoading: false});
          this.setState({paymentfailed: false});
          AsyncStorage.setItem('business_id', res.data.result.business);
          AsyncStorage.setItem('plan_id', res.data.result.plan_id);
          this.props.history.push('/createProfileServiceProvider');
        }
        console.log(res.data.error.message);
        const errors = [];
        if (res.data.error) {
          if (res.data.error.reason == 'payment error') {
            this.setState({paymentfailed: true});
          }
          this.setState({isLoading: false});
          errors.push(res.data.error.message);
          this.setState({errors});
          setTimeout(() => {
            this.setState({errors: []});
            // document.getElementById("error").remove();
            // document.getElementById('error').style.display = 'none'
          }, 3000);
          return errors;
        }
      })
      .catch((error) => {
        if (error.response) {
          const errors = [];
          if (error.response.data.error) {
            if (error.response.data.error.reason == 'payment error') {
              this.setState({paymentfailed: true});
            }
            this.setState({isLoading: false});
            errors.push(error.response.data.error.message);
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
              // document.getElementById("error").remove();
              // document.getElementById('error').style.display = 'none'
            }, 3000);
            return errors;
          }
        }
      });
  }
  failedonSubmitServiceProvider(e) {
    this.setState({isLoading: true});
    e.preventDefault();
    const {card_name, stripe_plan, plan_id, user_id, card_number, exp_date, cvc} = this.state;

    const errors = validate(card_name, card_number, exp_date, cvc);
    if (errors.length > 0) {
      this.setState({errors});
      this.setState({isLoading: false});
      setTimeout(() => {
        this.setState({errors: []});
        // this.props.history.push('/')
        // document.getElementById('error').style.display='none'
      }, 3000);
      return;
    } else {
      if (this.state.cardList.length > 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const card_create = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
        };
        console.log(card_create);
        axios
          .post(API_CALL_ENDPOINT + '/stripe/cards/create', card_create)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              const userpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                plan_id: this.state.plan_id,
                business_id: this.state.business_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.card_id,
              };
              console.log(userpayment);
              //  return

              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/update', userpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business);
                    AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                    this.props.history.push('/createProfileServiceProvider');
                  }
                  console.log(res.data.error.message);
                  if (res.data.error) {
                    if (res.data.error.reason == 'payment error') {
                      this.setState({paymentfailed: true});
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      if (error.response.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            if (res.data.status == 'conflict') {
              const existcardpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                plan_id: this.state.plan_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.details.card_no,
              };
              // console.log(userpayment)
              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business);
                    AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                    this.props.history.push('/createProfileServiceProvider');
                  }
                  console.log(res.data.error.message);
                  const errors = [];
                  if (res.data.error) {
                    if (res.data.error.reason == 'payment error') {
                      this.setState({paymentfailed: true});
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      if (error.response.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            // console.log(res.data.error.message)
            if (res.data.error) {
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                  // document.getElementById("error").remove();
                  // document.getElementById('error').style.display = 'none'
                }, 3000);
                return errors;
              }
              if (error.response.data.status == 'conflict') {
                const existcardpayment = {
                  apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                  secret: 'R1eqD2twI3E4',
                  user_id: this.state.user_id,
                  business_id: this.state.business_id,
                  plan_id: this.state.plan_id,
                  stripe_plan: this.state.stripe_plan,
                  payment_type: this.state.payment_type,
                  card_id: error.response.data.result.details.card_no,
                };
                // console.log(userpayment)
                axios
                  .post(API_CALL_ENDPOINT + '/profile/payment/update', existcardpayment)
                  .then((res) => {
                    console.log(res.data);
                    if (res.data.status == 'success') {
                      this.setState({isLoading: false});
                      this.setState({paymentfailed: false});
                      AsyncStorage.setItem('business_id', res.data.result.business);
                      AsyncStorage.setItem('plan_id', res.data.result.plan_id);
                      this.props.history.push('/createProfileServiceProvider');
                    }
                    console.log(res.data.error.message);
                    const errors = [];
                    if (res.data.error) {
                      if (res.data.error.reason == 'payment error') {
                        this.setState({paymentfailed: true});
                      }
                      this.setState({isLoading: false});
                      errors.push(res.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  })
                  .catch((error) => {
                    if (error.response) {
                      if (error.response.data.error) {
                        if (error.response.data.error.reason == 'payment error') {
                          this.setState({paymentfailed: true});
                        }
                        this.setState({isLoading: false});
                        errors.push(error.response.data.error.message);
                        this.setState({errors});
                        setTimeout(() => {
                          this.setState({errors: []});
                          // document.getElementById("error").remove();
                          // document.getElementById('error').style.display = 'none'
                        }, 3000);
                        return errors;
                      }
                    }
                  });
              }
            }
          });
      }
      if (this.state.cardList.length == 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const userpayment = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
          plan_id: this.state.plan_id,
          stripe_plan: this.state.stripe_plan,
          payment_type: this.state.payment_type,
        };
        console.log(userpayment);
        //  return

        axios
          .post(API_CALL_ENDPOINT + '/profile/payment/update', userpayment)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              this.setState({paymentfailed: false});
              AsyncStorage.setItem('business_id', res.data.result.business);
              AsyncStorage.setItem('plan_id', res.data.result.plan_id);
              this.props.history.push('/createProfileServiceProvider');
            }
            console.log(res.data.error.message);
            if (res.data.error) {
              if (res.data.error.reason == 'payment error') {
                this.setState({paymentfailed: true});
              }
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                if (error.response.data.error.reason == 'payment error') {
                  this.setState({paymentfailed: true});
                }
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                  // document.getElementById("error").remove();
                  // document.getElementById('error').style.display = 'none'
                }, 3000);
                return errors;
              }
            }
          });
      }
    }
  }

  getTempIDForonPayexistCardServiceProvider = (e) => {
    e.preventDefault();
    const TempID = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/business/temp/id', TempID)
      .then((res) => {
        console.log('res.data.result', res.data.result);
        this.setState({business_id: res.data.result.id});
        this.onPayexistCardServiceProvider();
        // document.getElementById('chooseplandtls_div').style.display = 'block';
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onPayexistCardServiceProvider(e) {
    this.setState({isLoading: true});
    this.getTempID();
    $('.processing_div').show();
    e.preventDefault();
    const existcardpayment = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      plan_id: this.state.plan_id,
      stripe_plan: this.state.stripe_plan,
      payment_type: this.state.payment_type,
      card_id: this.state.existcard_id,
      temp_business_id: this.state.business_id,
    };
    // console.log('existcardpayment', existcardpayment);
    // return;
    axios
      .post(API_CALL_ENDPOINT + '/profile/payment/create', existcardpayment)
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 'success') {
          this.setState({isLoading: false});
          this.setState({paymentfailed: false});
          AsyncStorage.setItem('business_id', res.data.result.business_id);
          AsyncStorage.setItem('plan_id', this.state.plan_id);
          // this.props.history.push('/createProfileServiceProvider');
        }
        console.log(res.data.error.message);
        const errors = [];
        if (res.data.error) {
          if (res.data.error.reason == 'payment error') {
            this.setState({paymentfailed: true});
          }
          this.setState({isLoading: false});
          errors.push(res.data.error.message);
          this.setState({errors});
          setTimeout(() => {
            this.setState({errors: []});
            // document.getElementById("error").remove();
            // document.getElementById('error').style.display = 'none'
          }, 3000);
          return errors;
        }
      })
      .catch((error) => {
        if (error.response) {
          const errors = [];
          if (error.response.data.error) {
            if (error.response.data.error.reason == 'payment error') {
              this.setState({paymentfailed: true});
            }
            this.setState({isLoading: false});
            errors.push(error.response.data.error.message);
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
              // document.getElementById("error").remove();
              // document.getElementById('error').style.display = 'none'
            }, 3000);
            return errors;
          }
        }
      });
  }

  onSubmitServiceProvider(e) {
    this.setState({isLoading: true});
    $('.processing_div').show();
    this.getTempID();
    e.preventDefault();
    const {card_name, stripe_plan, plan_id, user_id, card_number, exp_date, cvc} = this.state;

    const errors = validate(card_name, card_number, exp_date, cvc);
    if (errors.length > 0) {
      this.setState({errors});
      this.setState({isLoading: false});
      setTimeout(() => {
        this.setState({errors: []});
        // this.props.history.push('/')
        // document.getElementById('error').style.display='none'
      }, 3000);
      return;
    } else {
      if (this.state.cardList.length > 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const card_create = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
        };
        console.log(card_create);
        axios
          .post(API_CALL_ENDPOINT + '/stripe/cards/create', card_create)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              const userpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                plan_id: this.state.plan_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.card_id,
                temp_business_id: this.state.business_id,
              };
              console.log(userpayment);
              //  return

              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/create', userpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business_id);
                    AsyncStorage.setItem('plan_id', this.state.plan_id);
                    // this.props.history.push('/createProfileServiceProvider');
                  }
                  console.log(res.data.error.message);
                  if (res.data.error) {
                    this.card_list();
                    if (res.data.error.reason == 'payment error') {
                      if (res.data.error.id) {
                        this.setState({
                          paymentfailed: true,
                          business_id: res.data.error.id,
                        });
                        AsyncStorage.setItem('business_id', res.data.error.id);
                      }
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      this.card_list();
                      if (error.response.data.error.reason == 'payment error') {
                        if (error.response.data.error.id) {
                          this.setState({
                            paymentfailed: true,
                            business_id: error.response.data.error.id,
                          });
                          AsyncStorage.setItem('business_id', error.response.data.error.id);
                        }
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            if (res.data.status == 'conflict') {
              const existcardpayment = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                plan_id: this.state.plan_id,
                stripe_plan: this.state.stripe_plan,
                payment_type: this.state.payment_type,
                card_id: res.data.result.details.card_no,
                temp_business_id: this.state.business_id,
              };
              // console.log(userpayment)
              axios
                .post(API_CALL_ENDPOINT + '/profile/payment/create', existcardpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({isLoading: false});
                    this.setState({paymentfailed: false});
                    AsyncStorage.setItem('business_id', res.data.result.business_id);
                    AsyncStorage.setItem('plan_id', this.state.plan_id);
                    //  this.props.history.push('/createProfileServiceProvider');
                  }
                  console.log(res.data.error.message);
                  const errors = [];
                  if (res.data.error) {
                    this.card_list();
                    if (res.data.error.reason == 'payment error') {
                      if (res.data.error.id) {
                        this.setState({
                          paymentfailed: true,
                          business_id: res.data.error.id,
                        });
                        AsyncStorage.setItem('business_id', res.data.error.id);
                      }
                    }
                    this.setState({isLoading: false});
                    errors.push(res.data.error.message);
                    this.setState({errors});
                    setTimeout(() => {
                      this.setState({errors: []});
                      // document.getElementById("error").remove();
                      // document.getElementById('error').style.display = 'none'
                    }, 3000);
                    return errors;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      this.card_list();
                      if (error.response.data.error.reason == 'payment error') {
                        if (error.response.data.error.id) {
                          this.setState({
                            paymentfailed: true,
                            business_id: error.response.data.error.id,
                          });
                          AsyncStorage.setItem('business_id', error.response.data.error.id);
                        }
                      }
                      this.setState({isLoading: false});
                      errors.push(error.response.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  }
                });
            }
            // console.log(res.data.error.message)
            if (res.data.error) {
              this.card_list();
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.status == 'conflict') {
                const existcardpayment = {
                  apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                  secret: 'R1eqD2twI3E4',
                  user_id: this.state.user_id,
                  plan_id: this.state.plan_id,
                  stripe_plan: this.state.stripe_plan,
                  payment_type: this.state.payment_type,
                  card_id: error.response.data.result.details.card_no,
                  temp_business_id: this.state.business_id,
                };
                // console.log(userpayment)
                axios
                  .post(API_CALL_ENDPOINT + '/profile/payment/create', existcardpayment)
                  .then((res) => {
                    console.log(res.data);
                    if (res.data.status == 'success') {
                      this.setState({isLoading: false});
                      this.setState({paymentfailed: false});
                      AsyncStorage.setItem('business_id', res.data.result.business_id);
                      AsyncStorage.setItem('plan_id', this.state.plan_id);
                      //  this.props.history.push('/createProfileServiceProvider');
                    }
                    console.log(res.data.error.message);
                    const errors = [];
                    if (res.data.error) {
                      this.card_list();
                      if (res.data.error.reason == 'payment error') {
                        if (res.data.error.id) {
                          this.setState({
                            paymentfailed: true,
                            business_id: res.data.error.id,
                          });
                          AsyncStorage.setItem('business_id', res.data.error.id);
                        }
                      }
                      this.setState({isLoading: false});
                      errors.push(res.data.error.message);
                      this.setState({errors});
                      setTimeout(() => {
                        this.setState({errors: []});
                        // document.getElementById("error").remove();
                        // document.getElementById('error').style.display = 'none'
                      }, 3000);
                      return errors;
                    }
                  })
                  .catch((error) => {
                    if (error.response) {
                      if (error.response.data.error) {
                        this.card_list();
                        if (error.response.data.error.reason == 'payment error') {
                          if (error.response.data.error.id) {
                            this.setState({
                              paymentfailed: true,
                              business_id: error.response.data.error.id,
                            });
                            AsyncStorage.setItem('business_id', error.response.data.error.id);
                          }
                        }
                        this.setState({isLoading: false});
                        errors.push(error.response.data.error.message);
                        this.setState({errors});
                        setTimeout(() => {
                          this.setState({errors: []});
                          // document.getElementById("error").remove();
                          // document.getElementById('error').style.display = 'none'
                        }, 3000);
                        return errors;
                      }
                    }
                  });
              }
              // console.log(res.data.error.message)
              if (error.response.data.error) {
                this.card_list();
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                  // document.getElementById("error").remove();
                  // document.getElementById('error').style.display = 'none'
                }, 3000);
                return errors;
              }
            }
          });
      }
      if (this.state.cardList.length == 0) {
        var vals = this.state.exp_date.split('/');
        var exp_month = vals[0];
        var exp_year = vals[1];
        const userpayment = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          card_name: this.state.card_name,
          card_number: this.state.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvc: this.state.cvc,
          plan_id: this.state.plan_id,
          stripe_plan: this.state.stripe_plan,
          payment_type: this.state.payment_type,
          temp_business_id: this.state.business_id,
        };
        console.log(userpayment);
        //  return

        axios
          .post(API_CALL_ENDPOINT + '/profile/payment/create', userpayment)
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 'success') {
              this.setState({isLoading: false});
              this.setState({paymentfailed: false});
              AsyncStorage.setItem('business_id', res.data.result.business_id);
              AsyncStorage.setItem('plan_id', this.state.plan_id);
              //   this.props.history.push('/createProfileServiceProvider');
            }
            console.log(res.data.error.message);
            if (res.data.error) {
              if (res.data.error.reason == 'payment error') {
                if (res.data.error.id) {
                  this.setState({
                    paymentfailed: true,
                    business_id: res.data.error.id,
                  });
                  AsyncStorage.setItem('business_id', res.data.error.id);
                }
              }
              this.card_list();
              this.setState({isLoading: false});
              errors.push(res.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
                // document.getElementById("error").remove();
                // document.getElementById('error').style.display = 'none'
              }, 3000);
              return errors;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                if (error.response.data.error.reason == 'payment error') {
                  if (error.response.data.error.id) {
                    this.setState({
                      paymentfailed: true,
                      business_id: error.response.data.error.id,
                    });
                    AsyncStorage.setItem('business_id', error.response.data.error.id);
                  }
                }
                this.card_list();
                this.setState({isLoading: false});
                errors.push(error.response.data.error.message);
                this.setState({errors});
                setTimeout(() => {
                  this.setState({errors: []});
                  // document.getElementById("error").remove();
                  // document.getElementById('error').style.display = 'none'
                }, 3000);
                return errors;
              }
            }
          });
      }
    }
  }

  // logout() {
  //   localStorage.removeItem('token');
  //   console.log('loggedout');
  //   window.location.reload(true);
  //   // this.props.history.push('/signin')
  // }

  planchoose = () => {
    $('.processing_div').show();

    const subscription_renew = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/subscription/renew', subscription_renew)
      .then((res) => {
        if (res.data.status == 'success') {
          var clientSecret = res.data.result.client_secret;
          payment_client_secret_id = res.data.result.client_secret;
          this.setState({isLoading: false, payment_client_secret: res.data.result.client_secret});
          this.setState({paymentfailed: false});
          AsyncStorage.setItem('subscription_id', res.data.result.subscription_id);
          $('#chooseplandtls_div').hide();
          $('#creditcarddtls_div').show();
          $('.creditcarddtls_div').show();
          console.log('options', options);
          setTimeout(() => {
            $('.processing_div').hide();
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
  };
  planchoose_update(stripe_plan, plan_id, plan_name, plan) {
    $('.processing_div').show();
    console.log(plan);
    if (stripe_plan.length > 0) {
      this.setState(() => ({
        stripe_plan: stripe_plan,
        plan_id: plan_id,
        plan_name: plan_name,
        plan_details: plan,
      }));
      const userpayment = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        plan_id: plan_id,
        stripe_plan: stripe_plan,
        // payment_type: this.state.payment_type,
        // card_id: res.data.result.card_id,
        business_id: this.state.business_id,
      };
      axios
        .post(API_CALL_ENDPOINT + '/subscription/upgrade', userpayment)
        .then(async (res) => {
          console.log(res.data);
          if (res.data.status == 'success') {
            var clientSecret = res.data.result.client_secret;
            payment_client_secret_id = res.data.result.client_secret;
            this.setState({isLoading: false, payment_client_secret: res.data.result.client_secret});
            this.setState({paymentfailed: false});
            AsyncStorage.setItem('subscription_id', res.data.result.subscription_id);
            $('#chooseplandtls_div').hide();
            $('#creditcarddtls_div').show();
            $('.creditcarddtls_div').show();
            console.log('options', options);
            setTimeout(() => {
              $('.processing_div').hide();
            }, 2000);
          }
        })
        .catch((error) => {
          if (error.response) {
            const errors = [];
            if (error.response.data.error) {
              $('.processing_div').hide();
              this.card_list();
              if (error.response.data.error.reason == 'payment error') {
                if (error.response.data.error.id) {
                  this.setState({
                    paymentfailed: true,
                    business_id: error.response.data.error.id,
                  });
                  // AsyncStorage.setItem('business_id', error.response.data.error.id);
                }
              }
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              this.setState({isLoading: false});
            }
          }
        });
      // console.log(this.state.stripe_plan,this.state.plan_id)
    }
  }

  choose_serviceprovider(stripe_plan, plan_id, plan_name, plan) {
    console.log('stripe_plan', stripe_plan);
    console.log('plan_id', plan_id);
    console.log('plan_name', plan_name);
    console.log('plan', plan);
    if (stripe_plan.length > 0) {
      this.setState(() => ({
        stripe_plan: stripe_plan,
        plan_id: plan_id,
        plan_name: plan_name,
        plan_details: plan,
      }));
      $('#chooseplandtls_div').hide();
      $('.serviceprovidercreditcarddtls_div').show();
      $('#serviceprovidercreditcarddtls_div').show();
    }
  }
  back() {
    $('#chooseplandtls_div').show();
    $('#creditcarddtls_div').hide();
    $('.creditcarddtls_div').hide();
    $('.serviceprovidercreditcarddtls_div').hide();
    $('#serviceprovidercreditcarddtls_div').hide();
    $('.getphoneno_div').hide();
    this.setState({
      card_name: '',
      card_number: '',
      exp_date: '',
      cvc: '',
      exp_month: '',
      exp_year: '',

      existcard_id: '',
    });
  }
  componentWillUnmount() {
    removeCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/adminlte.min.css');
    removeCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/innerpages_customstyle.css');
  }
  componentDidMount() {
    loadCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/adminlte.min.css');
    loadCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/innerpages_customstyle.css');
    $('.changephno_clk').click(function () {
      $('.phoneverify_div').hide();
      $('.phoneno_div').show();
    });

    console.log('PAYMENTENDPOINT', PAYMENTENDPOINT);
    const socket = socketIOClient(PAYMENTENDPOINT);
    socket.on('payment_update', (data) => {
      console.log('process_status', process_status);
      var process_status = '1';
      console.log('socketresponse', data);
      if (data.status === 'success' && data.id === this.state.business_id) {
        $('.processing_div').hide();
        this.props.history.push('/create-profile1');
      } else if (data.status === 'action_required' && data.id === this.state.business_id) {
        process_status = '0';
        var contents = $('#payment_content').html();
        this.setState({payment_process_text: contents, action_required: true});
        var append_content = `<br>Please authorize the payment.<br> 
          <a href="https://invoice.stripe.com" 
  target="popup" 
  onclick="window.open('${data.invoice_url}','popup','width=600,height=600'); return false;">
  Pay Now
</a>`;
        $('#payment_content').html(append_content);
        console.log('process_status1', process_status);
      } else if (data.status === 'failed') {
        setTimeout(() => {
          this.payment_process_faild();
          // if (process_status == '1' ) {
          //   console.log("process_status2",process_status);
          //   $('.processing_div').hide();
          // }
        }, 3000);
      }
    });

    AsyncStorage.getItem('temp_business_id').then((temp_business_id) => {
      if (temp_business_id) {
        console.log('temp_business_id code');
        console.log(temp_business_id);
      }
    });

    AsyncStorage.getItem('user_email').then((user_email) => {
      if (user_email) {
        this.setState({user_email});
        console.log('email code');
        console.log(user_email);
      }
    });
    AsyncStorage.getItem('user_id').then((user_id) => {
      if (user_id) {
        this.setState({user_id});
        console.log('User_id');
        console.log(user_id);
      }
    });
    AsyncStorage.getItem('business_id').then((business_id) => {
      if (business_id) {
        this.setState({business_id});
        console.log('business_id');
        console.log(business_id);
      }
    });
    AsyncStorage.getItem('subscription_id').then((subscription_id) => {
      if (subscription_id) {
        this.setState({subscription_id});
        console.log('subscription_id');
        console.log(subscription_id);
      }
    });

    let url = this.props.location.search;
    let params = queryString.parse(url);
    if (params?.verified === 'true') {
      localStorage.setItem('token', 'loggedIn');
      AsyncStorage.setItem('user_id', params?.user);
      AsyncStorage.setItem('business_id', params?.profile);
      this.setState({
        loggedIn: true,
        user_id: params?.user,
        business_id: params?.profile,
        appsumo: 'true',
      });
      this.props.history.push('/renew-profile');
      window.location.reload(true);
    }else if (params?.payment_intent?.length != undefined && params?.payment_intent?.length != 0) {
      $('.hidden_row').hide();
      $('.processing_div').show();
      this.setState({payment_intent: params?.payment_intent});
      setTimeout(() => {
        this.checkPaymentStatus();
      }, 2500);
    }else if (params?.bid?.length != undefined && params?.bid?.length != 0) {
      this.setState({business_id:params?.bid});
      this.props.history.push('/renew-profile');
    } 

    setTimeout(() => {
      //this.card_list();
     this.planchoose();
      const user_free_check = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/user/free/check', user_free_check)
        .then((res) => {
          console.log('/user/free/check', res.data);
          this.setState({free_exist: res.data.result.free});
        })
        .catch((error) => {
          console.log(error);
        });

      const businessList = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/list', businessList)
        .then((res) => {
          console.log('/business/list', res.data);

          // console.log(res.data.result[0].phone_number.length)
          if (res.data.status === 'success') {
            this.setState({business_list_data: true});
            const onchangebusiness_name = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            axios
              .get(API_CALL_ENDPOINT + '/business/info', onchangebusiness_name)
              .then((res) => {
                console.log('/business/info', res.data);
                if (res.data.status === 'success') {
                  this.setState({business_details: res?.data?.result?.business});
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.setState({business_list_data: false});
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }, 500);
  }

  checkPaymentStatus = () => {
    const IntendDetails = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        payment_intent: this.state.payment_intent,
        subscription_id: this.state.subscription_id,
        user_id: this.state.user_id,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/payment/intent/status', IntendDetails)
      .then((res) => {
        console.log('psuccess', res);
        $('.processing_div').hide();
        toast.dark(res.data.message, {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 2000);
        // this.props.history.push('/create-profile1');
      })
      .catch((error) => {
        setTimeout(() => {
          this.checkPaymentStatus();
        }, 2500);
      });
  };
  card_list = () => {
    const card_List = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/stripe/cards/list', card_List)
      .then((res) => {
        console.log(res.data.result);

        if (res.data.result) {
          this.setState({cardList: res.data.result.cards});
        } else {
          console.log('no cards found');
          this.setState({cardList: []});
          document.getElementById('choosecrd').style.display = 'none';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  trialplan_clk(plan) {
    console.log('plan', plan);
    // if (plan.plan_id.length > 0) {
    this.setState(() => ({
      stripe_plan: plan?.plan_id,
      plan_id: plan._id,
      plan_name: plan.plan_name,
    }));
    $('.chooseplandtls_div').hide();
    $('.getphoneno_div').show();
    // }
  }
  verify_number() {
    if (this.state.user_otp.length != 4) {
      const errors = [];
      errors.push('Please check the OTP entered.');
      this.setState({errors});
      setTimeout(() => {
        this.setState({errors: []});
      }, 3000);
    } else {
      const OTP_Verify = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        phone_number: this.state.user_phone_number_code + this.state.user_phone_number,
        otp: this.state.user_otp,
        plan_id: this.state.plan_id,
      };
      axios
        .post(API_CALL_ENDPOINT + '/user/phone/verify', OTP_Verify)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            this.setState({CreateProfileclass: 'all_contentcntr_800'});
            AsyncStorage.setItem('business_id', res.data.result._id);
            this.setState({
              business_id: res.data.result._id,
            });
            var trial_phone = '';
            if (res.data.result.phone_number) {
              const prifix = res.data.result.phone_number.substring(1, 0);

              if (prifix == '1' || prifix == '0') {
                trial_phone = res.data.result.phone_number.substring(1);
                trial_phone = trial_phone
                  .replace(/[^\dA-Z]/g, '')
                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                  .trim();

                this.setState({Trial_phone_number: trial_phone});
              } else {
                trial_phone = res.data.result.phone_number
                  .replace(/[^\dA-Z]/g, '')
                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                  .trim();

                this.setState({Trial_phone_number: trial_phone});
              }
            }
            $('#Create_profilestep1').hide();
            $('#Create_profilestep2').show();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'conflict') {
              const errors = [];
              errors.push(error.response.data.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
              }, 4000);
            }
          }
        });
    }
  }
  phoneverify_clk() {
    if (this.state.user_phone_number.length === 0) {
      const errors = [];
      errors.push('Please enter the phone number.');
      this.setState({errors});
      return false;
    }
    const phone_Verify = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      phone_number: this.state.user_phone_number_code + this.state.user_phone_number,
    };

    axios
      .post(API_CALL_ENDPOINT + '/user/api/phone', phone_Verify)
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 'success') {
          $('.phoneno_div').hide();
          $('.phoneverify_div').show();
          this.startTimer();
        }
        if (res.data.status === 'conflict') {
          const errors = [];
          errors.push(res.data.message);
          this.setState({errors});
          setTimeout(() => {
            this.setState({errors: []});
          }, 4000);
        }
        if (res.data.error) {
          if (res.data.error.error_type === 'number_format') {
            const errors = [];
            errors.push(this.state.user_phone_number + ' is not a valid phone number');
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
            }, 5000);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'conflict') {
            const errors = [];
            errors.push(error.response.data.message);
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
            }, 4000);
          }
          if (error.response.data.error) {
            if (error.response.data.error.error_type === 'number_format') {
              const errors = [];
              errors.push(this.state.user_phone_number + ' is not a valid phone number');
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
              }, 5000);
            }
          }
        }
      });
  }
  onChange_trial_businessname(e) {
    this.setState({trial_business_name: e.target.value});
  }
  update_trial_name() {
    if (!this.state.trial_business_name) {
      const errors = [];
      errors.push('Workspace name is mandatory');
      this.setState({errors});
      setTimeout(() => {
        this.setState({errors: []});
      }, 5000);
    } else {
      const Profile_update = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        business_name: this.state.trial_business_name,
        plan_id: this.state.plan_id,
        setup: 'trial',
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/profile/update', Profile_update)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            AsyncStorage.setItem('business_name', res.data.result.business_name);
            this.props.history.push('/create-profile3');
          }
          if (res.data.error) {
            const errors = [];
            errors.push(res.data.error.message);
            this.setState({errors});
            setTimeout(() => {
              this.setState({errors: []});
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              const errors = [];
              errors.push(error.response.data.error.message);
              this.setState({errors});
              setTimeout(() => {
                this.setState({errors: []});
              }, 5000);
            }
          }
        });
    }
  }
  startTimer = () => {
    $('.ResendOtpTimer').show();
    $('.ResendOtp').hide();
    // settimerDisplay('flex');
    let tempTimer = 30;
    const timer = setInterval(() => {
      if (tempTimer > 0) {
        tempTimer = tempTimer - 1;
        this.setState({timerValue: this.state.timerValue - 1});
        // settimerValue((prev) => prev - 1);
      } else {
        $('.ResendOtpTimer').hide();
        $('.ResendOtp').show();
        tempTimer = 30;
        this.setState({timerValue: tempTimer});
        clearInterval(timer);
      }
    }, 1000);
  };
  update = (value) => {
    return () => {
      this.setState({
        run: value,
      });
    };
  };

  contact_us_email = (e) => {
    e.preventDefault();
    const contact_us = {
      apikey: API_KEY,
      secret: API_SECRET,
      email_address: this.state.user_email,
    };
    console.log('contact_us', contact_us);
    axios
      .post(API_CALL_ENDPOINT + '/user/enterprise', contact_us)
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 'success') {
          this.setState(() => ({
            cntus_cls: 'alert alert-success text-center',
            cntus_msg: 'Thank you for showing interest we will get back to you shortly.',
          }));
          setTimeout(() => {
            this.setState({cntus_cls: '', cntus_msg: ''});
          }, 5000);
        } else if (res.data.error) {
          this.setState(() => ({
            cntus_cls: 'alert alert-danger text-center',
            cntus_msg: 'Please try again later',
          }));
          setTimeout(() => {
            this.setState({cntus_cls: '', cntus_msg: ''});
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              cntus_cls: 'alert alert-danger text-center',
              cntus_msg: 'Please try again later',
            }));
            setTimeout(() => {
              this.setState({cntus_cls: '', cntus_msg: ''});
            }, 5000);
          }
        }
      });
  };
  cart_update = (value) => {
    if (value === 'true') {
      console.log('updated');
    }
  };
  
  render() {
    console.log('this.state.temp_business_id', this.state.temp_business_id);
    const initial = this.state.user_email.substring(1, 0);
    const firstinitial = initial.toUpperCase();
    const {errors} = this.state;
    if (this.state.loggedIn === false) {
      // return <Redirect to="/signin" />;
    }
    const {plans, plans_year} = this.state;
    return (
      <>
        <Helmet>
          <title>Redtie - Create Workspace</title>
        </Helmet>

        <div className="hold-transition sidebar-collapse layout-top-nav accent-custom">
          <div className="wrapper">
            <ToastContainer
              transition={Flip}
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            {/* Navbar */}
            <Header_component data={this.update.bind(this)} cart_data={this.cart_update.bind(this)} />
            {/* /.navbar */}
            {/* Main Sidebar Container */} {/*Can be used when needed*/}
            <aside className="main-sidebar sidebar-light-gray-dark elevation-3" style={{display: 'none'}}>
              {/* Sidebar */}
              <div className="sidebar">
                {/* Sidebar user panel (optional) */}
                <div className="user-panel mt-2 pt-3 mb-3 d-flex flex-wrap text-center elevation-1">
                  <div className="image w-100 pl-0 pb-2">
                    <img src={no_image} className="img-circle elevation-2" alt="User Image" />
                  </div>
                  <div className="info w-100">
                    <h6 className="d-block font-weight-semibold text-white">
                      <span>{/*Alexander Pierce*/}alexander....@gmail.com</span>{' '}
                      <i className="fas fa-angle-down crsr_pntr user_menutgl f_sz18 postop_2" />
                    </h6>
                  </div>
                  <div className="user_menu w-100 all_link bg-white" style={{display: 'none'}}>
                    <a href className="mx-4 my-3 d-inline-block isdisabled">
                      <span className="fmaroon">
                        <i className="fas fa-user-edit" title="Edit Account" />
                      </span>
                    </a>
                    <a href className="mx-4 my-3 d-inline-block isdisabled">
                      <span className="fmaroon">
                        <i className="fas fa-file-invoice-dollar" title="Billing" />
                      </span>
                    </a>
                    <a href className="mx-4 my-3 d-inline-block fmaroon">
                      <span className="fmaroon">
                        <i className="fas fa-sign-out-alt" title="Logout" />
                      </span>
                    </a>
                  </div>
                </div>
                {/* Sidebar Menu */}
                <nav className="mt-2">
                  <ul
                    className="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false">
                    {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
                    <li className="nav-item">
                      <a href className="nav-link active">
                        {/*<i class="nav-icon far fa-building"></i>*/}
                        <img src={transparent} className="m_createprofile" />
                        <p>Create Workspace</p>
                      </a>
                    </li>
                    <li className="nav-item ismenudisabled">
                      <a href className="nav-link">
                        {/*<i class="nav-icon fas fa-chart-line"></i>*/}
                        <img src={transparent} className="m_board isdisabled" />
                        <p>Board</p>
                      </a>
                    </li>
                    <li className="nav-item ismenudisabled">
                      <a href className="nav-link">
                        {/*<i class="nav-icon fas fa-sliders-h"></i>*/}
                        <img src={transparent} className="m_settings isdisabled" />
                        <p>Settings</p>
                      </a>
                    </li>
                  </ul>
                </nav>
                {/* /.sidebar-menu */}
              </div>
              {/* /.sidebar */}
            </aside>
            {/* Content Wrapper. Contains page content */}
            <div className="content-wrapper">
              {/* Content Header (Page header) */}
              <div className="content-header">
                <div className="container-fluid">
                  <div className="row mb-2">
                    <div className="col-sm-12">
                      <div className="header_pagetitle d-block d-sm-block d-md-none">
                        <div className="text-center pt-2">
                          <h4>Create a Workspace</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /.row */}
                </div>
                {/* /.container-fluid */}
              </div>
              {/* /.content-header */}
              {/* Main content */}
              <div className="content">
                <div className="container-fluid">
                  <div className="row hidden_row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className={this.state.CreateProfileclass}>
                        <div
                          className="all_contentflex_div mt-0 mt-sm-3 mb-5 align-items-center brdr_radius_div"
                          id="Create_profilestep1">
                          <div className="col-12 col-sm-12 col-md-12 px-0 brdr_radius_div">
                            {/* <div>
                              <div className="allpage_title text-center pt-2 pt-sm-4">
                                <h4>
                                  <span className="fmaroon">Step 1:</span>{' '}
                                  <span>
                                    {this.state.appsumo === 'true'
                                      ? 'You are currently in AppSumo special plan'
                                      : 'Choose a Plan'}
                                  </span>
                                </h4>
                              </div>
                            </div> */}
                            <div className="creditcarddtls_div">
                              <div className="all_content_div mt-3">
                                <div className="all_contentcntr_450">
                                  <div className="card w-100 mb-0 bx_shadow_sm">
                                    {/* <div className="card-header">
                                      <div className="card-title text-center w-100">
                                        <div className="payment_switch mt-3 text-center">
                                          <label className="switch">
                                            <input type="checkbox" className="typeselect_tgl" />
                                            <div className="slider round" />
                                          </label>
                                        </div>
                                      </div>
                                    </div> */}
                                    <div className="form-horizontal formbiglbl">
                                      <div className="card-body">
                                        <div className="card_tgldiv w-100">
                                          <div className="brdrbtm_dashed pb-3 mb-3">
                                            <div className="form-group row mb-4">
                                              <h5 className="col-5 col-sm-5 col-md-5 pt-3 col-form-label">Plan</h5>
                                              <div className="col-7 col-sm-7 col-md-7">
                                                <div className="pt-3">
                                                  {' '}
                                                  {this.state?.business_details?.plan_id?.plan_type === 'month'
                                                    ? 'Monthly'
                                                    : 'Annually'}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="form-group row mb-4">
                                              <h5 className="col-5 col-sm-5 col-md-5 pt-3 col-form-label">
                                                Payment Date
                                              </h5>
                                              <div className="col-7 col-sm-7 col-md-7">
                                                <div className="pt-3">{moment(this.state.business_details?.start_date).format('MMMM DD,YYYY')}</div>
                                              </div>
                                            </div>
                                            <div className="form-group row mb-4">
                                              <h5 className="col-5 col-sm-5 col-md-5 pt-3 col-form-label">
                                                Renewal Date
                                              </h5>
                                              <div className="col-7 col-sm-7 col-md-7">
                                                <div className="pt-3">
                                                  {moment(this.state.business_details?.expire_date).format('MMMM DD,YYYY')}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="form-group row mb-4">
                                              <h5 className="col-5 col-sm-5 col-md-5 pt-3 col-form-label">Total</h5>
                                              <div className="col-7 col-sm-7 col-md-7">
                                                <h5 className="pt-3">
                                                  <span className="fgreen4">
                                                    ${' '}
                                                    {this.state.business_details?.plan_id?.plan_type === 'month'
                                                      ? this.state.business_details?.plan_id?.dollar
                                                      : this.state.business_details?.plan_id?.dollar / 12}
                                                    /month* 
                                                    {this.state.business_details?.plan_id?.plan_type === 'month'
                                                      ? ''
                                                      : " $ "+ this.state.business_details?.plan_id?.dollar +"/year"}
                                                    
                                                  </span>
                                                </h5>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="choosecrd">
                                            <div className="form-group row mb-4">
                                              <h4 className="cardchosen_ortxt">
                                                <span>Choose Card</span>
                                              </h4>
                                              <div className="col-12 col-sm-12 col-md-12">
                                                <div className="select_style">
                                                  <select className="form-control" onChange={this.onChangecard_id}>
                                                    <option>Select</option>
                                                    {this.state.cardList.map((cards) => {
                                                      var month = new Date().getMonth() + 1;
                                                      var year = new Date().getFullYear();
                                                      var New_date = new Date();
                                                      return New_date.getTime() >
                                                        new Date(
                                                          cards.exp_year,
                                                          cards.exp_month - 1,
                                                        ).getTime() ? undefined : (
                                                        <option key={cards.id} value={cards.id}>
                                                          xxxx-xxxx-xxxx-
                                                          {cards.card_number} - {cards.brand}
                                                        </option>
                                                      );
                                                    })}
                                                  </select>
                                                </div>
                                              </div>
                                            </div>

                                            <h4 className="cardchosen_ortxt">
                                              <span>New Card Details</span>
                                            </h4>
                                          </div>
                                          {errors.map((error) => (
                                            <div id="error" className="alert alert-danger text-center" key={error}>
                                              {error}
                                            </div>
                                          ))}
                                          <div
                                            className="f_sz12 fred mt-1 text-left text-md-left pr-2"
                                            style={{display: this.state.existcard_id ? 'block' : 'none'}}>
                                            *Note - Please Unselect Card To Enable New Card Details
                                          </div>
                                          {this.state?.payment_client_secret !== '' ? (
                                            <Elements
                                              stripe={stripePromise}
                                              options={{clientSecret: this.state?.payment_client_secret, appearance}}>
                                              <StripePaymentElement
                                                isBack={this.back}
                                                onSubmitStripe={this.onSubmitStripe}
                                              />
                                            </Elements>
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* /.row */}
                </div>
                {/* /.container-fluid */}
              </div>
              {/* /.content */}
            </div>
            {/* /.content-wrapper */}
            {/* Main Footer */}
            {/* <Footer_component /> */}
          </div>

          {/* ./wrapper */}
          {/* REQUIRED SCRIPTS */}
          {/* jQuery */}
          {/**/}
          {/* Bootstrap 4 */}
          {/**/}
          {/* AdminLTE App */}
        </div>
      </>
    );
  }
}
